import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Header, Icon } from 'semantic-ui-react';
import { entityUrl } from '@/constants/urls';
import { auditIcon } from '../constants';

const AuditPanelHeader = ({
  category,
  code,
  value,
  className,
}) => {
  const intl = useIntl();
  if (!value) {
    return null;
  }

  return (
    <Header
      as="a"
      href={entityUrl(category, code, '#')}
      className={clsx('aridhia-audit-panel-header primary aridhia-h2 mb-0', className)}
      rel="noopener noreferrer"
    >
      <Icon name={auditIcon(category)} />
      <Header.Content content={intl.formatMessage({ id: 'tabs.history.of' }, { name: value })} />
    </Header>
  );
};

export default AuditPanelHeader;
